import {createGlobalStyle, css} from 'styled-components';
import {globalStyleBody} from "@/styles/global/globalStyleBody";
import {globalStyleTypographyColor} from "@/styles/global/globalStyleTypographyColor";
import {globalStyleGap} from "@/styles/global/globalStyleGap";
import {globalStyleForm} from "@/styles/global/globalStyleForm";
import { devices, theme } from 'styles/theme';

export default createGlobalStyle`

    ${globalStyleBody}
    ${globalStyleTypographyColor}
    ${globalStyleGap}
    ${globalStyleForm}
    
    section, .swiper-wrapper, .cursor, .cursor-inner-text, .image-wrapper-second, .fix-it-right-two, .fix-it-right, .fix-it-left-two, .fix-it-left.fix-it-left-main, .fix-it-right-main {
        will-change: transform;
    }
    #smooth-wrapper {
        position: relative;
        height: 100vh; /* or 100% viewport height */
        overflow: hidden;
        
        ${devices.sm}{
            height: auto;
            overflow: unset;
        }
    }

    #smooth-content {
        min-height: 100vh; /* at least fill viewport */
        overflow: visible;
    }

    section[aria-live="polite"] {
        position: relative;
        z-index: 99999999999999999999999;
        will-change: unset !important;
    }

    .swiper-button-disabled {
        opacity: 0.5;
    }

    .overlay {
        height: 100vh;
        position: fixed;
        width: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 9;
        display: none;

        &.show {
            display: block;
        }
    }

    .swiper-pagination-bullet {
        outline: none;
    }

    .swiper-slide {
        height: auto;
    }

    .hover {
        position: relative;
        overflow: hidden;

        span {
            z-index: 2;
        }

        &:after {
            content: '';
            position: absolute;
            height: 0;
            width: 0;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            background-color: ${theme.colors.hover};
            transition: all .5s ease;
            border-radius: 19px;
        }

        &:hover {
            &:after {
                height: 100%;
                width: 100%;
            }
        }
    }

    .modal-backdrop {
        background-color: ${theme.colors.modalBg};
        min-width: 100%;

        &.show {
            opacity: 1;
        }
    }


    .overlay-main-bg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        height: 100vh;
        background: ${theme.colors.black50};
        backdrop-filter: blur(10px);
        z-index: 999999;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }


    //cursor
    .cursor.-hidden:before {
        transform: scale(0.2) !important;
    }

    .cursor {
        display: block !important;
        visibility: visible !important;
        will-change: transform;

        &:before {
            background: ${theme.colors.secondaryGreen} !important;
        }

        &.-hidden {
            display: block !important;
            visibility: visible !important;
        }
    }

    .cursor-media {
        display: none !important;

        video {
            display: none !important;
        }
    }


    //animation text css
    .fade-up {
        will-change: transform;
    }

    .split-parent, .anim-text-title {
        overflow: hidden;
    }

    .split-child {
        overflow: hidden;
        display: inline-block;
    }

    .split-child {
        overflow: hidden;
    }
`;


